var _path, _path2, _path3, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55417 0.285811C8.15976 -0.10079 7.52662 -0.0944604 7.14002 0.299949L0.840002 6.72721C0.453401 7.12162 0.45973 7.75475 0.854139 8.14136C1.24855 8.52796 1.88168 8.52163 2.26828 8.12722L7.8683 2.41409L13.5814 8.01411C13.9758 8.40072 14.609 8.39439 14.9956 7.99998C15.3822 7.60557 15.3758 6.97243 14.9814 6.58583L8.55417 0.285811ZM8.99995 15.5772L8.85411 0.989954L6.85421 1.00995L7.00005 15.5972L8.99995 15.5772Z",
    fill: "#ECEDEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.8372C2 13.2849 1.55228 12.8372 1 12.8372C0.447715 12.8372 0 13.2849 0 13.8372H2ZM0 13.8372L0 21.4206H2L2 13.8372H0Z",
    fill: "#ECEDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.8372C16 13.2849 15.5523 12.8372 15 12.8372C14.4477 12.8372 14 13.2849 14 13.8372H16ZM14 13.8372V21.4206H16V13.8372H14Z",
    fill: "#ECEDEA"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 20.4207,
    x2: 15.0002,
    y2: 20.4207,
    stroke: "#ECEDEA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLogo);
export default __webpack_public_path__ + "static/media/upload-logo.9247104c1f1fe5a285e87e4ae8db19e6.svg";
export { ForwardRef as ReactComponent };